import type { LucideIcon } from 'lucide-react'

import {
    Clapperboard,
    Compass,
    Ghost,
    Gift,
    Image,
    LayoutGrid,
    PenTool,
    PersonStanding,
    Swords,
    Terminal,
    UserRound,
    WandSparkles
} from 'lucide-react'

const icons: Record<string, LucideIcon> = {
    'ai-video-generators': Clapperboard,
    'ai-image-generators': Image,
    'ai-avatars': UserRound,
    'ai-animation': PersonStanding,
    'ai-photo-editing': WandSparkles,
    'ai-design-tools': PenTool,
    'free-tools': Gift,
    'open-source': Terminal,
    'shut-down': Ghost,
    'matchups': Swords,
    'use-cases': Compass
}

// Categories added later in the CMS fall back to a neutral grid icon.
export const iconFor = (slug: string): LucideIcon => icons[slug] ?? LayoutGrid
